import Vue from 'vue'
import axios from 'axios'

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios.create({
      responseType: 'json',
      withCredentials: true,
      withXSRFToken: true,
      validateStatus: function (status) {
        return status < 500; // Resolve only if the status code is less than 500
      }
    })
  }
})
